export default {
    checkin: {
        new_media_delivered: 'pica/notification/picacode/{picacode}/new_media',
    },
    gallery: {
        new_public_media: 'pica/notification/pica_service/{pica_service_id}/gallery/{gallery_id}/new_public_media',
        all_public_media: 'pica/notification/pica_service/{pica_service_id}/gallery/*/new_public_media',
    },
    galleryTree: {
        new_public_media: 'pica/notification/pica_service/{pica_service_id}/gallery/{gallery_id}/new_public_media',
        all_public_media: 'pica/notification/pica_service/{pica_service_id}/gallery/*/new_public_media',
        picacode_update: 'pica/notification/picacode/{picacode}/new_media',
    },
}